/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * What the criteria threshold measures
 * @export
 */
export const StreakThresholdUnit = {
    COUNT: 'COUNT',
    MINUTES: 'MINUTES',
    AMOUNT: 'AMOUNT',
    DISTINCT_DAYS: 'DISTINCT_DAYS'
} as const;
export type StreakThresholdUnit = typeof StreakThresholdUnit[keyof typeof StreakThresholdUnit];


export function instanceOfStreakThresholdUnit(value: any): boolean {
    for (const key in StreakThresholdUnit) {
        if (Object.prototype.hasOwnProperty.call(StreakThresholdUnit, key)) {
            if (StreakThresholdUnit[key as keyof typeof StreakThresholdUnit] === value) {
                return true;
            }
        }
    }
    return false;
}

export function StreakThresholdUnitFromJSON(json: any): StreakThresholdUnit {
    return StreakThresholdUnitFromJSONTyped(json, false);
}

export function StreakThresholdUnitFromJSONTyped(json: any, ignoreDiscriminator: boolean): StreakThresholdUnit {
    return json as StreakThresholdUnit;
}

export function StreakThresholdUnitToJSON(value?: StreakThresholdUnit | null): any {
    return value as any;
}

export function StreakThresholdUnitToJSONTyped(value: any, ignoreDiscriminator: boolean): StreakThresholdUnit {
    return value as StreakThresholdUnit;
}

